module.exports = __webpack_public_path__ + "static/media/KW12_as1.18dd165a.png";